export const Checkbox = ({label, checked, onChange}) => (
    <label className="checkbox">
      <input type="checkbox" checked={checked} onChange={onChange} />
      {label}
    </label>
);
